// extracted by mini-css-extract-plugin
export var company = "styles-module--company--b80d8";
export var companyName = "styles-module--companyName--e98eb";
export var logo = "styles-module--logo--fdd7a";
export var logoLink = "styles-module--logoLink--095e8";